import * as actions from './actions'
import mutations from './mutations'

const state = {
  loading: false,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
